import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Dictionary 📖</h1>
      </header>
      <Dictionary />
    </div>
  );
}

export default App;
